import type { RestorationPlan } from "../../types/dental";

interface GenericToolboxProps {
  plan: RestorationPlan;
  onUpdatePlan: (planId: string, updates: Partial<RestorationPlan>) => void;
}

export function GenericToolbox({ plan, onUpdatePlan }: GenericToolboxProps) {
  return (
    <section className="procedure-toolbox-card card">
      <h3>Procedure Toolbox</h3>

      <div className="field-stack">
        <div className="field-row">
          <label>Catalog Item</label>
          <input
            type="text"
            value={plan.selectedCatalogItem || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, {
                selectedCatalogItem: e.target.value,
              })
            }
          />
        </div>

        <div className="field-row">
          <label>Material</label>
          <input
            type="text"
            value={plan.material || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { material: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Design Notes</label>
          <textarea
            value={plan.designNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { designNotes: e.target.value })
            }
          />
        </div>
      </div>
    </section>
  );
}